import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export const ZebraPreview = ({ ciclo, cliente }) => {
  const qrUrl = ciclo?.id ? `${window.location.origin}/consulta/${ciclo.id}` : '';

  return (
    <div
      data-testid="zebra-preview"
      className="font-mono bg-white border-2 border-black p-4 w-[300px] h-[200px] flex flex-col justify-between"
    >
      <div>
        <div className="text-sm font-bold mb-1 truncate">{cliente?.nome || 'N/A'}</div>
        <div className="text-xs mb-1">Ciclo: {ciclo?.numero_ciclo || 'N/A'}</div>
        <div className="text-xs mb-2">
          Validade: {ciclo?.data_validade ? new Date(ciclo.data_validade).toLocaleDateString('pt-BR') : 'N/A'}
        </div>
      </div>
      <div className="flex justify-center">
        {qrUrl && <QRCodeCanvas value={qrUrl} size={80} />}
      </div>
    </div>
  );
};